import { Box, Stack, useTheme } from "@mui/material";
import React from "react";

import { SteelGrade } from "src/store/api/generatedApi";
import { SteelGradeChip } from "./SteelGradeChip";
import { EditableDescription } from "./EditableDescription";

interface Props {
  steelGrades: SteelGrade[];
  selectedSteelGradeIds: number[];
  focusedSteelGradeId?: number | null;
  onClick?: (id: number) => void;
  description?: string;
  setDescription?: (description: string) => void;
  descriptionEndAdornment?: React.ReactNode;
}

export const BaseSteelGradesCell = ({
  steelGrades,
  selectedSteelGradeIds,
  focusedSteelGradeId = null,
  onClick,
  description,
  setDescription,
  descriptionEndAdornment,
}: Props) => {
  const theme = useTheme();

  const handleOnClick = (id: number) => {
    if (onClick) {
      onClick(id);
    }
  };

  const [mixSelectedSteelGrades, notMixSelectedSteelGrades] =
    React.useMemo(() => {
      return [
        steelGrades.filter((steelGrade) =>
          selectedSteelGradeIds.includes(steelGrade.id)
        ),
        steelGrades.filter(
          (steelGrade) => !selectedSteelGradeIds.includes(steelGrade.id)
        ),
      ] as const;
    }, [selectedSteelGradeIds, steelGrades]);

  return (
    <Stack
      sx={{
        height: "100%",
        justifyContent: "space-between",
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          gap: 0.4,
          flexWrap: "wrap",
          paddingY: 1,
          paddingX: 0.5,
          overflow: "auto",
          height: `calc(100% - ${theme.spacing(2 + (description ? 5 : 0))})`,
          alignItems: "flex-start",
        }}
      >
        {mixSelectedSteelGrades.map((steelGrade) => {
          return (
            <SteelGradeChip
              key={steelGrade.id}
              label={steelGrade.name}
              selected
              focused={steelGrade.id === focusedSteelGradeId}
              onClick={() => {
                handleOnClick(steelGrade.id);
              }}
            />
          );
        })}
        {mixSelectedSteelGrades.length > 0 ? (
          <Box sx={{ flexBasis: "100%", height: theme.spacing(0.5) }} />
        ) : null}
        {notMixSelectedSteelGrades.map((steelGrade) => {
          return (
            <SteelGradeChip
              key={steelGrade.id}
              label={steelGrade.name}
              onClick={() => {
                handleOnClick(steelGrade.id);
              }}
              focused={steelGrade.id === focusedSteelGradeId}
              selected={false}
            />
          );
        })}
      </Stack>
      {description !== undefined || setDescription != undefined ? (
        <EditableDescription
          description={description}
          setDescription={setDescription}
          endAdornment={descriptionEndAdornment}
        />
      ) : null}
    </Stack>
  );
};
